/**
 * /advertisers/rbac — advertiser RBAC landing (OPUS-144).
 *
 * Declares the TanStack Router route and delegates rendering to
 * `AdvertiserRbacPage`. The flat-file naming convention uses dots as path
 * separators, so `advertisers.rbac.tsx` maps to `/advertisers/rbac`.
 *
 * Follows the same shape as `advertisers.portal.tsx` so the central wire-up
 * can import and mount this module without touching the feature tree.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { AdvertiserRbacPage } from "@/features/advertiser-rbac/AdvertiserRbacPage";

// ---------------------------------------------------------------------------
// Route — mounts at `/advertisers/rbac`. `tab` is the only declared search
// param so deep links can land on the assignments panel directly.
// ---------------------------------------------------------------------------

interface AdvertisersRbacSearch {
	tab?: "matrix" | "assignments";
}

export const advertisersRbacRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertisers/rbac",
	validateSearch: (raw: Record<string, unknown>): AdvertisersRbacSearch => {
		const tab = raw.tab;
		if (tab === "matrix" || tab === "assignments") {
			return { tab };
		}
		return {};
	},
	component: AdvertiserRbacPage,
});

export default advertisersRbacRoute;

// Re-export the page so the central router module can import it from a
// single source if that's the preferred wire-up pattern.
export { AdvertiserRbacPage } from "@/features/advertiser-rbac/AdvertiserRbacPage";
